<ul class="controparti m0">
	<li  class="panel" *ngFor="let soggetto of soggetti; let indice = index">
		<div class="controparte">
			<div>
				<a data-toggle="collapse" aria-expanded="true"
					(click)="openDetail(soggetto, indice)"
					[attr.aria-controls]="labelComponent + indice" data-parent="#controparticollapse"
					class="{{activeIndex === indice ? 'accordion-collapse' : 'accordion-collapsed'}} mt-toggle"><span>Apri</span></a>

				<p class="col-sm-2 button-associa">
					<button class="btn btn-danger associa" (click)="disassocia(soggetto.option)">Disassocia</button>
				</p>
				<h4 class="titolo col-sm-4 mt-5"
					*ngIf="soggetto.option.parte.tipoPersona?.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_FISICA">
					<a data-toggle="collapse"
						(click)="openDetail(soggetto, indice)" aria-expanded="false"
						[attr.aria-controls]="labelComponent + indice"
						data-parent="#controparticollapse">{{soggetto.option.parte.cognome}}
						{{soggetto.option.parte.nome}}</a>
				</h4>
				<h4 class="titolo col-sm-4 mt-5"
					*ngIf="soggetto.option.parte.tipoPersona?.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_GIURIDICA">
					<a data-toggle="collapse"
						(click)="openDetail(soggetto, indice)" aria-expanded="false"
						[attr.aria-controls]="labelComponent + indice"
						data-parent="#controparticollapse">{{soggetto.option.parte.ragioneSociale}}</a>
				</h4>
				<p class="col-sm-4 matricola mt-5"
					*ngIf="soggetto.option.parte.tipoPersona?.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_FISICA">
					C/F: <strong>{{soggetto.option.parte.codiceFiscale}}</strong>
				</p>
				<p class="col-sm-4 matricola mt-5"
					*ngIf="soggetto.option.parte.tipoPersona?.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_GIURIDICA">
					P.IVA: <strong>{{soggetto.option.parte.partitaIva}}</strong>
				</p>
				<p class="col-sm-2 matricola mt-5" *ngIf="soggetto.option.parte.id?.startsWith('TEMP')">
					<span class="label label-success">Nuova anagrafica</span>
				</p>

			</div>
		</div>
 		<ul class="{{activeIndex === indice ? 'collapsed' : 'collapse'}} subcontroparte" >
			<li *ngIf="parteSelected && editingParte">
				<div class="container_dati_generali">
					<app-anagrafica-parte-form *ngIf="parteSelected === soggetto.option" [parte]="parteSelected.parte" (parteChange)="retrieveParte($event , soggetto.option )" [labelButton] = "'Modifica'"></app-anagrafica-parte-form>
				</div>
			</li>

			<li *ngIf="!parteSelected">
				<div class="container_dati_generali">
					<div class="container_tab_nav" *ngIf="soggetto.option.categoriaAltraParte != null">
						<ul class="nav nav-tabs two">
						<li (click)="setTab('ASSOCIATIVA')"
              class="{{currentTab === 'ASSOCIATIVA' ? 'active' : 'inactive'}}">
                <a>Associativa</a>
              </li>
              <li (click)="setTab('ANAGRAFICA')"
              class="{{currentTab === 'ANAGRAFICA' ? 'active' : 'inactive'}}">
                <a>Anagrafica</a>
              </li>
						</ul>
					  </div>
					  <div *ngIf="currentTab == 'ASSOCIATIVA'">
						<div class="row">
						  <div
							labelTextInput
							class="col-sm-6 bloccodati"
							[typeLabel]="'text'"
							[labelInput]="'Categoria'"
							[valueInput]="soggetto.option.categoriaAltraParte?.label"
						  ></div>
						</div>
						<div class="row">
						  <div
							labelTextInput
							class="col-sm-6 bloccodati"
							[typeLabel]="'text'"
							[labelInput]="'Rinunciatario'"
							[valueInput]="soggetto.option.ritirato ? 'Sì' : 'No'"
						  ></div>
						  <div
							labelTextInput
							class="col-sm-6 bloccodati"
							[typeLabel]="'date'"
							[labelInput]="'Data Rinuncia'"
							[valueInput]="soggetto.option.dataTermine"
						  ></div>
						</div>
						<div class="row">
						  <div
							labelTextInput
							class="col-sm-12 bloccodati"
							[typeLabel]="'text'"
							[labelInput]="'Note'"
							[valueInput]="soggetto.option.note"
						  ></div>
						</div>
					  </div>
					  <div *ngIf="currentTab == 'ANAGRAFICA'">
              <div class="row">
                <div
                  labelTextInput
                  class="col-sm-4 bloccodati"
                  [typeLabel]="'text'"
                  [labelInput]="'Cognome e Nome'"
                  [valueInput]="soggetto.option.parte?.cognome+' '+soggetto.option.parte?.nome"
                ></div>
                <div
                  labelTextInput
                  class="col-sm-4 bloccodati"
                  [typeLabel]="'text'"
                  [labelInput]="'Tipo persona'"
                  [valueInput]="soggetto.option.parte?.tipoPersona?.label"
                ></div>
                <div
                  labelTextInput
                  class="col-sm-4 bloccodati"
                  [typeLabel]="'text'"
                  [labelInput]="'Dipendente'"
                  [valueInput]="soggetto.option.parte?.dipendente|booleanTransform"
                ></div>
              </div>
              <div class="row">
                <div
                  labelTextInput
                  class="col-sm-4 bloccodati"
                  [typeLabel]="'text'"
                  [labelInput]="'Codice fiscale'"
                  [valueInput]="soggetto.option.parte?.codiceFiscale"
                ></div>
                <div
                  labelTextInput
                  class="col-sm-4 bloccodati"
                  [typeLabel]="'text'"
                  [labelInput]="'Sesso'"
                  [valueInput]="soggetto.option.parte?.sesso != null ? soggetto.option.parte?.sesso : ''"
                ></div>
                <div
                  labelTextInput
                  class="col-sm-4 bloccodati"
                  [typeLabel]="'text'"
                  [labelInput]="'Matricola'"
                  [valueInput]="soggetto.option.parte?.matricola"
                ></div>
              </div>
              <div class="row">
                <div
                  labelTextInput
                  class="col-sm-3 bloccodati"
                  [typeLabel]="'text'"
                  [labelInput]="'Ragione Sociale'"
                  [valueInput]="soggetto.option.parte?.ragioneSociale"
                ></div>
                <div
                  labelTextInput
                  class="col-sm-3 bloccodati"
                  [typeLabel]="'text'"
                  [labelInput]="'Partita Iva'"
                  [valueInput]="soggetto.option.parte?.partitaIva"
                ></div>
                <div
                  labelTextInput
                  class="col-sm-3 bloccodati"
                  [typeLabel]="'text'"
                  [labelInput]="'CF Rappresentante legale'"
                  [valueInput]="soggetto.option.parte?.codiceFiscaleRappresentanteLegale"
                ></div>
                <div
                    labelTextInput
                    class="col-sm-3 bloccodati"
                    [typeLabel]="'text'"
                    [labelInput]="'Tipo società'"
                    [valueInput]="soggetto.option.parte?.tipoSocieta?.label"
                  ></div>
              </div>
              <div class="row container_fieldset">
                <fieldset class="form-group">
                  <legend>Nascita</legend>
                  <div class="row">
                    <div
                      labelTextInput
                      class="col-sm-2 bloccodati"
                      [typeLabel]="'date'"
                      [labelInput]="'Data'"
                      [valueInput]="soggetto.option.parte?.dataNascita"
                    ></div>
                    <div
                      labelTextInput
                      class="col-sm-5 bloccodati"
                      [typeLabel]="'text'"
                      [labelInput]="'Comune'"
                      [valueInput]="soggetto.option.parte?.comuneNascita?.label"
                    ></div>
                    <div
                      labelTextInput
                      class="col-sm-5 bloccodati"
                      [typeLabel]="'text'"
                      [labelInput]="'Provincia'"
                      [valueInput]="soggetto.option.parte?.provinciaNascita?.label"
                    ></div>
                  </div>
                </fieldset>
              </div>
              <div class="row container_fieldset">
                <fieldset class="form-group">
                  <legend>Residenza</legend>
                  <div class="row">
                    <div
                      labelTextInput
                      class="col-sm-9 bloccodati"
                      [typeLabel]="'text'"
                      [labelInput]="'Indirizzo'"
                      [valueInput]="soggetto.option.parte?.indirizzo"
                    ></div>
                    <div
                      labelTextInput
                      class="col-sm-3 bloccodati"
                      [typeLabel]="'text'"
                      [labelInput]="'CAP'"
                      [valueInput]="soggetto.option.parte?.cap"
                    ></div>
                  </div>
                  <div class="row">
                    <div
                      labelTextInput
                      class="col-sm-6 bloccodati"
                      [typeLabel]="'text'"
                      [labelInput]="'Comune'"
                      [valueInput]="soggetto.option.parte?.comuneResidenza?.label"
                    ></div>
                    <div
                      labelTextInput
                      class="col-sm-6 bloccodati"
                      [typeLabel]="'text'"
                      [labelInput]="'Provincia'"
                      [valueInput]="soggetto.option.parte?.provinciaResidenza?.label"
                    ></div>
                  </div>
                </fieldset>
              </div>
              <div class="row container_fieldset">
                <fieldset class="form-group">
                  <legend>Contatti</legend>
                  <div class="row">
                    <div
                      labelTextInput
                      class="col-sm-4 bloccodati"
                      [typeLabel]="'text'"
                      [labelInput]="'Telefono'"
                      [valueInput]="soggetto.option.parte?.telefono"
                    ></div>
                    <div
                      labelTextInput
                      class="col-sm-4 bloccodati"
                      [typeLabel]="'text'"
                      [labelInput]="'Cellulare'"
                      [valueInput]="soggetto.option.parte?.cellulare"
                    ></div>
                    <div
                      labelTextInput
                      class="col-sm-4 bloccodati"
                      [typeLabel]="'text'"
                      [labelInput]="'Fax'"
                      [valueInput]="soggetto.option.parte?.fax"
                    ></div>
                  </div>
                  <div class="row">
                    <div
                      labelTextInput
                      class="col-sm-6 bloccodati"
                      [typeLabel]="'text'"
                      [labelInput]="'Email'"
                      [valueInput]="soggetto.option.parte?.email"
                    ></div>
                    <div
                      labelTextInput
                      class="col-sm-6 bloccodati"
                      [typeLabel]="'text'"
                      [labelInput]="'Pec'"
                      [valueInput]="soggetto.option.parte?.pec"
                    ></div>
                  </div>
                </fieldset>
              </div>
              <div class="row">
                <div
                  labelTextInput
                  class="col-sm-12 bloccodati"
                  [typeLabel]="'text'"
                  [labelInput]="'Note'"
                  [valueInput]="soggetto.option.parte?.note"
                ></div>
              </div>
					  </div>

				</div>
			</li>
			<p class="col-sm-3 col-sm-offset-9 col-xs-3 col-xs-offset-9">
        <button *ngIf="!parteSelected" type="button" class="btn btn-primary btn-block"
          (click)="parteSelected = soggetto.option">Modifica
          dati</button>
      </p>
		</ul>
	</li>
</ul>
